import React from 'react';
import { DeductionDto } from '@/shared/api/deductionApi';
import { Supplier } from '@/features/partner/supplierStatus/types/supplier.types';
import { SelectOption } from '@/shared/components/forms/SearchableSelect';
import { formatCurrency } from '@/shared/utils/formatter';
import RiderToHeadAddRow, { NewDeductionForm } from './RiderToHeadAddRow';

const ITEMS_PER_PAGE = 10;

interface RiderToHeadTableProps {
    loading: boolean;
    currentItems: DeductionDto[];
    currentPage: number;
    deductions: DeductionDto[];
    suppliers: Supplier[];
    deductionTypes: Array<{ code: string; name: string }>;
    newDeduction: NewDeductionForm;
    supplierOptions: SelectOption[];
    formRiderOptions: SelectOption[];
    deductionTypesLoading: boolean;
    suppliersLoading: boolean;
    formRidersLoading: boolean;
    previewDays: number;
    previewTotal: number;
    onDelete: (seqNo: number) => void;
    onFormSuppIdChange: (suppId: string) => void;
    onRiderChange: (riderId: string) => void;
    onDeductionTypeChange: (code: string, name: string) => void;
    onDeductionNameChange: (name: string) => void;
    onDeductionAmountChange: (amount: string) => void;
    onStartDateChange: (value: string) => void;
    onEndDateChange: (value: string) => void;
    onDeductDaysChange: (value: string) => void;
    onAddDeduction: () => void;
}

const RiderToHeadTable: React.FC<RiderToHeadTableProps> = ({
                                                               loading,
                                                               currentItems,
                                                               currentPage,
                                                               deductions,
                                                               suppliers,
                                                               deductionTypes,
                                                               newDeduction,
                                                               supplierOptions,
                                                               formRiderOptions,
                                                               deductionTypesLoading,
                                                               suppliersLoading,
                                                               formRidersLoading,
                                                               previewDays,
                                                               previewTotal,
                                                               onDelete,
                                                               onFormSuppIdChange,
                                                               onRiderChange,
                                                               onDeductionTypeChange,
                                                               onDeductionNameChange,
                                                               onDeductionAmountChange,
                                                               onStartDateChange,
                                                               onEndDateChange,
                                                               onDeductDaysChange,
                                                               onAddDeduction,
                                                           }) => {
    const getSupplierName = (suppId: string): string =>
        suppliers.find(s => s.id === suppId)?.name ?? suppId;

    const getDeductionTypeName = (code: string): string =>
        deductionTypes.find(t => t.code === code)?.name ?? code;

    const formatPeriod = (startDay: string, endDay: string): string => {
        if (!startDay && !endDay) return '-';
        if (!endDay) return `${startDay} ~`;
        if (!startDay) return `~ ${endDay}`;
        return `${startDay} ~ ${endDay}`;
    };

    return (
        <div className="rider-to-head-table-container">
            <table className="supplier-selection-table" style={{ minWidth: '1470px', tableLayout: 'auto' }}>
                <thead>
                <tr>
                    <th style={{ width: '60px' }}>NO</th>
                    <th style={{ width: '180px' }}>대상</th>
                    <th style={{ width: '180px' }}>세부대상</th>
                    <th style={{ width: '120px' }}>공제타입</th>
                    <th style={{ width: '180px' }}>공제명</th>
                    <th style={{ width: '110px' }}>공제금액</th>
                    <th style={{ width: '580px' }}>기간 / 차감 일수</th>
                    <th style={{ width: '80px' }}>등록</th>
                </tr>
                </thead>
                <tbody>
                {currentItems.length === 0 && !loading ? (
                    <tr>
                        <td colSpan={8} className="text-center text-gray-600">
                            조회된 일차감 내역이 없습니다.
                        </td>
                    </tr>
                ) : (
                    currentItems.map((deduction, index) => (
                        <tr key={deduction.seqNo}>
                            <td className="text-center">
                                {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}
                            </td>
                            <td>{getSupplierName(deduction.suppId)}</td>
                            <td>{deduction.riderId || '-'}</td>
                            <td className="text-center">{getDeductionTypeName(deduction.deductType)}</td>
                            <td>{deduction.deductName}</td>
                            <td className="text-right">{formatCurrency(String(deduction.deductAmt || 0))}원</td>
                            <td className="text-center">
                                {formatPeriod(deduction.startDay, deduction.endDay)}
                                {deduction.deductCnt != null && (
                                    <span style={{ color: '#888', marginLeft: '6px', fontSize: '12px' }}>
                                            ({deduction.deductCnt}일)
                                        </span>
                                )}
                            </td>
                            <td className="text-center">
                                <button
                                    className="btn-delete"
                                    onClick={() => onDelete(deduction.seqNo)}
                                >
                                    삭제
                                </button>
                            </td>
                        </tr>
                    ))
                )}

                <RiderToHeadAddRow
                    newDeduction={newDeduction}
                    supplierOptions={supplierOptions}
                    formRiderOptions={formRiderOptions}
                    deductionTypes={deductionTypes}
                    deductionTypesLoading={deductionTypesLoading}
                    suppliersLoading={suppliersLoading}
                    formRidersLoading={formRidersLoading}
                    previewDays={previewDays}
                    previewTotal={previewTotal}
                    onFormSuppIdChange={onFormSuppIdChange}
                    onRiderChange={onRiderChange}
                    onDeductionTypeChange={onDeductionTypeChange}
                    onDeductionNameChange={onDeductionNameChange}
                    onDeductionAmountChange={onDeductionAmountChange}
                    onStartDateChange={onStartDateChange}
                    onEndDateChange={onEndDateChange}
                    onDeductDaysChange={onDeductDaysChange}
                    onAddDeduction={onAddDeduction}
                />
                </tbody>
            </table>
        </div>
    );
};

export default RiderToHeadTable;
